import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, ArrowRight, Database, Settings, Users, Zap } from "lucide-react";

const NichePage = ({ title, subtitle, sections, technology }) => (
  <div>
    <section className="py-20 bg-slate-50 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h1 className="text-4xl sm:text-5xl text-[#2D4A6D] mb-6 font-serif">{title}</h1>
        <div className="w-16 h-0.5 bg-[#2D4A6D] mx-auto mb-6" />
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">{subtitle}</p>
      </div>
    </section>

    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-6">
          {sections.map((sec, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}>
              <div className="p-8 border border-slate-200 hover:border-[#2D4A6D]/50 transition-colors">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-[#2D4A6D] flex items-center justify-center flex-shrink-0">
                    <sec.icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-xl font-semibold text-[#2D4A6D]">{sec.name}</h3>
                </div>
                <div className="flex flex-wrap gap-2 mt-4">
                  {sec.items.map((item, j) => (
                    <span key={j} className="inline-flex items-center gap-1 text-xs text-slate-600 bg-slate-100 px-3 py-1">
                      <CheckCircle className="w-3 h-3 text-[#2D4A6D]" />{item}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {technology && technology.length > 0 && (
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl text-[#2D4A6D] mb-4 font-serif">Technology</h2>
            <div className="w-16 h-0.5 bg-[#2D4A6D] mx-auto" />
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {technology.map((tool, i) => (
              <span key={i} className="text-sm text-slate-600 bg-white border border-slate-200 px-4 py-2">{tool}</span>
            ))}
          </div>
        </div>
      </section>
    )}

    <section className="py-20 bg-[#2D4A6D] text-white">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h2 className="text-3xl sm:text-4xl mb-6 font-serif">Discuss Requirements</h2>
        <div className="w-16 h-0.5 bg-white/30 mx-auto mb-8" />
        <p className="text-slate-300 mb-10">
          Schedule a strategy call to identify operational requirements and determine the appropriate engagement structure.
        </p>
        <Link to="/book">
          <button className="bg-white text-[#2D4A6D] hover:bg-slate-100 px-10 py-4 font-medium flex items-center mx-auto">
            Book a Strategy Call <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </Link>
      </div>
    </section>
  </div>
);

export { NichePage, CheckCircle, ArrowRight, Database, Settings, Users, Zap };
